import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  title: string;
  editAction?: () => void;
  minWidth?: number;
  classContent?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

const GeneralInfoItem: React.FC<Props> = (props) => {
  const { title, editAction, minWidth, classContent, children, disabled } = props;
  const style = minWidth ? { minWidth } : undefined;
  return (
    <div style={style} className="gi-item">
      <div className="gi-header">
        <div className="gi-title">{title}</div>
        {editAction && (
          <button type="button" onClick={editAction} className="gi-icon" disabled={disabled}>
            <FontAwesomeIcon icon="edit" style={disabled ? { color: '#c4c4c4' } : {}} />
          </button>
        )}
      </div>
      <div className={`gi-content${classContent ? `--${classContent}` : ''}`}>{children}</div>
    </div>
  );
};

export default GeneralInfoItem;
